import { render, staticRenderFns } from "./WaitResultTickets.vue?vue&type=template&id=5e1389a3&"
import script from "./WaitResultTickets.vue?vue&type=script&lang=js&"
export * from "./WaitResultTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports